import React, {useEffect, useState} from 'react';
import {v4 as uuid} from 'uuid';

interface Props {
  value: any;
}

export default function InnerHtml({value}: Props) {
  const [id, setId] = useState(uuid());

  useEffect(() => {
    if (!!value) {
      const el = document.getElementById(id);
      if (!!el) {
        el.innerHTML = value;
      }
    }
  }, [value]);

  return (
    <div id={id}>

    </div>
  );
};
